import { render, staticRenderFns } from "./UserSharing.vue?vue&type=template&id=6845e364&scoped=true"
import script from "./UserSharing.vue?vue&type=script&lang=js"
export * from "./UserSharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6845e364",
  null
  
)

export default component.exports